<template>
  <div style="padding: 20px; height: 100%">
    <div
      style="
        padding: 20px;
        border-radius: 10px;
        box-shadow: 0 0 5px 1px #e2e2e2;
        height: 100%;
      "
    >
      <ul
        style="
          border-bottom: 1px solid #e2e2e2;
          padding-bottom: 10px;
          font-size: 13px;
          font-weight: 600;
        "
      >
        修改密码
      </ul>
      <el-form
        :model="state.model"
        label-width="100px"
        style="width: 40%; margin-top: 10px"
        :scroll-to-error="true"
        ref="domForm"
        :rules="rules"
      >
        <el-form-item
          label="原密码"
          prop="OldPassword"
          :rules="[
            { required: true, message: '请填写原密码', trigger: 'blur' },
          ]"
        >
          <el-input type="password" v-model="state.model.OldPassword" />
        </el-form-item>
        <el-form-item
          label="新密码"
          prop="NewPassword"
          :rules="[
            { required: true, message: '请填写新密码', trigger: 'blur' },
          ]"
        >
          <el-input type="password" v-model="state.model.NewPassword" />
        </el-form-item>
        <el-form-item
          label="确认密码"
          prop="ConfirmPassword"
          :rules="[
            { required: true, message: '请再次输入新密码', trigger: 'blur' },
          ]"
        >
          <el-input type="password" v-model="state.model.ConfirmPassword" />
        </el-form-item>
        <el-form-item>
          <el-button style="width: 80px" type="primary" @click="onSubmit()">
            提交
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { home_setuser } from "@/http/home";
import { ElMessageBox } from "element-plus";
import { useRouter } from "vue-router";

export default {
  setup() {
    const router = useRouter();
    const domForm = ref(null);
    const state = reactive({
      model: {},
      roleList: [],
    });
    onMounted(() => {});

    const validatePassword = (rule, value, callback) => {
      if (value !== state.model.NewPassword) {
        callback(new Error("两次密码不一致"));
      }

      return callback();
    };

    //自定义校验必须放在校验方法后面
    const rules = {
      OldPassword: [
        { required: true, message: "请填写原密码", trigger: "blur" },
      ],
      NewPassword: [
        { required: true, message: "请填写新密码", trigger: "blur" },
      ],
      ConfirmPassword: [
        { required: true, message: "请再次输入新密码", trigger: "blur" },
        { validator: validatePassword, trigger: "blur" },
      ],
    };

    const onSubmit = () => {
      domForm.value.validate((valid) => {
        if (!valid) return false;

        const data = {
          password_old: state.model.OldPassword,
          password: state.model.NewPassword,
          password_confirm: state.model.NewPassword,
        };

        home_setuser(data).then((res) => {
          if (res.status == 200) {
            ElMessageBox.alert("修改成功,请重新登录", "提示", {
              type: "success",
              confirmButtonText: "确定",
              callback: () => {
                localStorage.removeItem("token");
                router.go(0);
              },
            });
          }
        });
      });
    };
    return { state, onSubmit, domForm, rules };
  },
};
</script>
<style scoped></style>
